<template>
  <div class="device">
    <el-card class="left">
      <div class="leftTop">
        <div class="leftTopTitle">
          <span>{{ sumecInfo.deviceName || '--' }}</span>
          <span>({{ sumecInfo.deviceNumber || '--' }})</span>
          <div class="state" :class="sumecInfo.deviceStatus === '1' ? 'green' : ''">
            {{ sumecInfo.deviceStatus === '1' ? '在线' : '离线' }}
          </div>
        </div>
        <el-tabs v-model="active">
          <el-tab-pane label="设备信息" name="DeviceInfo">
            <div class="deviceInfo">
              <div class="deviceTop">
                <p class="title">任务信息</p>
                <el-table v-loading="workLoading" :data="taskInfoData" class="global-table">
                  <el-table-column label="工作日" show-overflow-tooltip prop="week"></el-table-column>
                  <el-table-column label="工作时间段" show-overflow-tooltip>
                    <template v-slot="{ row }">
                      <span>{{ row.time1Start }} - {{ row.time1End }}</span>
                      <span class="timeDis">{{ row.time2Start ? row.time2Start + ' - ' : '' }}{{ row.time2End }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <ul>
                  <li>
                    <p>周期性工作：
                      <el-switch v-model="controlData.cuttp" active-value="1" inactive-value="2" active-text="关"
                        inactive-text="开" inactive-color="#BFBFBF" active-color="#1B85FF" :disabled='true'>
                      </el-switch>
                    </p>
                  </li>
                  <li>
                    <p>割草间隔时间：{{ controlData.cuttpNum || '' }}天</p>
                  </li>
                  <li>
                    <p>预设割草面积：{{ sumecInfo.mowingArea || '--' }}㎡</p>
                    <el-link type="primary" @click="getWorkArea()" class="getWorkArea">查看作业区域</el-link>
                  </li>
                </ul>
              </div>
              <div class="deviceMiddle">
                <p class="title">运行信息</p>
                <ul v-if="sumecInfo.runState === '4'">
                  <li>
                    <p>当前状态：
                      <span class="state blue">充电</span>
                    </p>
                    <p>充满剩余：<span>{{ sumecInfo.chargeRemaining || '--' }}</span></p>
                  </li>
                  <li>
                    <p>当前电量：<span>{{ sumecInfo.quantityElectricity || '--' }}%</span></p>
                    <p>已充时长：<span>{{ sumecInfo.fullTime || '--' }}</span></p>
                  </li>
                  <li>
                    <p>充电电流：<span>{{ sumecInfo.chargingCurrent || '--' }}A</span></p>
                  </li>
                </ul>
                <ul v-else-if="['1', '2', '3'].includes(sumecInfo.runState)">
                  <li>
                    <p>当前状态：
                      <span class="state yellow">
                        {{ sumecInfo.runState === '1' ? '待机' : sumecInfo.runState === '2' ? '回仓' : sumecInfo.runState
                          ===
                          '3' ? '休眠等待'
                          : '' }}
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>当前电量：<span>{{ sumecInfo.quantityElectricity || '--' }}%</span></p>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <p>当前状态：
                      <span v-if="sumecInfo.runState === '0'" class="state green">割草</span>
                      <span v-else-if="sumecInfo.runState === '4'" class="state blue">充电</span>
                      <span class="state" v-else>--</span>
                    </p>
                    <p>割草时长：<span>{{ sumecInfo.mowingLong || '--' }}</span></p>
                  </li>
                  <li>
                    <p>当前电量：<span>{{ sumecInfo.quantityElectricity || '--' }}</span></p>
                    <p>本次剩余：<span>{{ sumecInfo.restTime || '--' }}</span></p>
                  </li>
                  <li>
                    <p>割草进度：<span>{{ sumecInfo.mowingProgress || '--' }}%</span></p>
                    <p>完工剩余：<span>{{ sumecInfo.completionSurplus || '--' }}</span></p>
                  </li>
                </ul>
                <div class="warning" v-if="sumecInfo.faultInformation">
                  <i class="el-icon-warning"></i>
                  <span class="warningName">故障信息</span>
                  <span>{{ sumecInfo.faultInformation || '--' }}</span>
                </div>
              </div>
              <div class="main">
                <div class="mainLeft">
                  <p class="title">卫星定位信息</p>
                  <ul>
                    <li>
                      <div class="signal">
                        <div :class="['1', '5', '4'].includes(sumecInfo.positioningStatus) ? '' : 'gray'"></div>
                        <div :class="['5', '4'].includes(sumecInfo.positioningStatus) ? '' : 'gray'"></div>
                        <div :class="sumecInfo.positioningStatus === '4' ? '' : 'gray'"></div>
                        <div :class="sumecInfo.positioningStatus === '4' ? '' : 'gray'"></div>
                      </div>
                      <p>定位状态</p>
                    </li>
                    <li>
                      <div class="satellite">
                        <div>{{ sumecInfo.positioningSatellites || '--' }}</div>
                      </div>
                      <p>定位卫星数</p>
                    </li>
                    <li>
                      <div class="signal">
                        <div :class="['1', '5', '4'].includes(sumecInfo.orientationState) ? '' : 'gray'"></div>
                        <div :class="['5', '4'].includes(sumecInfo.orientationState) ? '' : 'gray'"></div>
                        <div :class="sumecInfo.orientationState === '4' ? '' : 'gray'"></div>
                        <div :class="sumecInfo.orientationState === '4' ? '' : 'gray'"></div>
                      </div>
                      <p>定向状态</p>
                    </li>
                    <li>
                      <div class="satellite">
                        <div>{{ sumecInfo.directionalSatellites || '--' }}</div>
                      </div>
                      <p>定向卫星数</p>
                    </li>
                    <li>
                      <div>{{ sumecInfo.altitude || '--' }}</div>
                      <p>海拔高度(m)</p>
                    </li>
                  </ul>
                </div>
                <div class="mainRight">
                  <p class="title">航行信息</p>
                  <ul>
                    <li>
                      <div>{{ sumecInfo.course || '--' }}</div>
                      <p>航向(°)</p>
                    </li>
                    <li>
                      <div>{{ sumecInfo.speed || '--' }}</div>
                      <p>速度(cm/s)</p>
                    </li>
                    <li>
                      <div>{{ sumecInfo.slope || '--' }}</div>
                      <p>坡度(°)</p>
                    </li>
                    <li>
                      <div>{{ sumecInfo.rollAngle || '--' }}</div>
                      <p>横滚角(°)</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="控制台" name="ControlBoard">
            <div class="controlBoard">
              <div class="machine">
                <div class="imgs" :class="sumecInfo.deviceStatus === '1' ? 'machineImg' : 'offLine'"></div>
                <div class="machineBtn">
                  <div class="syncInfo" :class="sumecInfo.deviceStatus === '1' ? 'onSyncInfo' : ''"
                    @click="sumecInfo.deviceStatus === '1' && syncInformation()">
                    <div></div>
                    <div>同步信息</div>
                  </div>
                  <div class="rainWork">
                    <el-switch v-model="controlData.rain" active-value="1" inactive-value="2" active-color="#1AD1B0"
                      inactive-color="#BFBFBF" active-text="雨天作业" inactive-text="雨天作业" @change="changeRainWork()"
                      :disabled='!isOrder || sumecInfo.deviceStatus === "2"'>
                    </el-switch>
                  </div>
                  <div class="ledLamp" :class="sumecInfo.deviceStatus === '1' ? 'onLed' : 'offLineLed'"
                    @click="sumecInfo.deviceStatus === '1' && getLed()">LED灯</div>
                </div>
              </div>
              <div class="setUp">
                <div class="backWash" :class="sumecInfo.deviceStatus === '1' ? 'onBW' : 'offLineBW'"
                  @click="sumecInfo.deviceStatus === '1' && chargeDevice()">
                  <div class="bwImg"></div>
                  <div class="bwTxt">回充</div>
                </div>
                <div class="backWash" :class="sumecInfo.deviceStatus === '1' ? 'onBW' : 'offLineBW'"
                  @click="sumecInfo.deviceStatus === '1' && syncTime()">
                  <div class="bwImg imgTwo"></div>
                  <div class="bwTxt">同步时间</div>
                </div>
                <div class="backWash" :class="sumecInfo.deviceStatus === '1' ? 'onBW' : 'offLineBW'"
                  @click="sumecInfo.deviceStatus === '1' && isOrder && getTaskConfig()">
                  <div class="bwImg imgThree"></div>
                  <div class="bwTxt">任务设置</div>
                </div>
              </div>
              <div :class="sumecInfo.deviceStatus === '1' ? 'deviceControl' : 'offLineDc'"
                @click="sumecInfo.deviceStatus === '1' && openDevice()">启动</div>
              <div :class="sumecInfo.deviceStatus === '1' ? 'deviceControl' : 'offLineDc'"
                @click="sumecInfo.deviceStatus === '1' && mapChange()">{{ deviceMapName || '区域选择' }}<icon
                  class="el-icon-arrow-right icon-right"></icon>
              </div>
              <div :class="sumecInfo.deviceStatus === '1' ? 'deviceControl closeColor' : 'offLineDc'"
                @click="sumecInfo.deviceStatus === '1' && closeDevice()">停止</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <el-card class="right">
      <div class="info">
        <p class="title">历史运行信息</p>
        <!-- <ul>
          <li>
            <p>总割草面积(㎡)</p>
            <p>{{sumecStatistics.mowingAreaTotal || '--'}}</p>
          </li>
          <li>
            <p>总运行时长</p>
            <p>{{sumecStatistics.runningTimeTotal || '--'}}</p>
          </li>
          <li>
            <p>总充电次数(次)</p>
            <p>{{sumecStatistics.chargeCountTotal || '--'}}</p>
          </li>
        </ul> -->
      </div>
      <div class="search mb20">
        <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" :clearable="false"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </div>

      <el-table class="global-table" v-loading="loading" :data="tableData">
        <el-table-column label type="index" :index="indexMethod"></el-table-column>
        <el-table-column label="时间" prop="collectTime" min-width="120px">
          <template v-slot="{ row }">
            <span>{{ row.collectTime }}-{{ row.collectTimeEnd }}</span>
          </template>
        </el-table-column>
        <el-table-column label="本轮割草时长" prop="actualLongTime"></el-table-column>
        <el-table-column label="本轮割草面积" prop="mowingArea">
        </el-table-column>
      </el-table>
      <!-- <el-table
      class="global-table"
      v-loading="loading"
      :data="tableData"
      :row-key="getRowKeys"
      :expand-row-keys="expands"
      @expand-change="expandChange"
      >
        <el-table-column type="expand">
          <template v-slot="{ row }">
            <el-table
              class="global-table child-table"
              :indent="0"
              ref="tableWrap"
              v-loading="childLoading"
              :data="row.childTableData"
              border
              max-height="500"
            >
              <el-table-column label type="index" :index="indexMethod"></el-table-column>
              <el-table-column label="时间" prop="collectTime" min-width="120px">
                <template v-slot="{ row } ">
                  <span>{{row.collectTime}}-{{row.collectTimeEnd}}</span>
                </template>
              </el-table-column>
              <el-table-column label="本轮割草时长" prop="actualLongTime"></el-table-column>
              <el-table-column label="本轮割草面积" prop="mowingArea">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="割草记录" show-overflow-tooltip prop="collectTime" min-width="280px">
          <template v-slot="{ row }">
            {{row.collectTime || ''}}-{{row.collectTimeEnd || ''}}
          </template>
        </el-table-column>
        <el-table-column label="割草时长" show-overflow-tooltip prop="actualLongTime" min-width="100px"></el-table-column>
        <el-table-column label="割草面积（㎡）" show-overflow-tooltip prop="mowingArea" min-width="120px"></el-table-column>
      </el-table> -->
      <global-pagination @size-change="getTableData" @current-change="getTableData" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>
    </el-card>

    <el-dialog title="任务设置" :visible="dialogVisible1" :destroy-on-close="true" :close-on-click-modal="false"
      width="900px" class="dialog-form" @close="closeSubmit()">
      <table v-loading="taskLoading">
        <el-table class="global-table mb20 dlg-table" max-height="400" :data="taskData" ref="form">
          <el-table-column label="工作日" width="60px" align='center' prop="week">
            <template v-slot="{ row }">
              <el-checkbox v-model="row.isWork" :true-label="'1'" :false-label="'2'"
                :checked="row.isWork === '1' ? true : false">
                {{ row.week }}
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="工作时间段" min-width="670px" align='center'>
            <template v-slot="{ row }">
              <div class="dates">
                <div class="date">
                  <el-time-select v-model="row.time1Start" :picker-options="{
                    start: '00:00',
                    step: '00:15',
                    end: row.time1End ? row.time1End : '23:45'
                  }" placeholder="选择开始时间" :disabled="row.isWork === '2'">
                  </el-time-select>
                  <span> - </span>
                  <el-time-select v-model="row.time1End" :picker-options="{
                    start: row.time1Start ? row.time1Start : '00:00',
                    step: '00:15',
                    end: '23:45',
                    minTime: row.time1Start
                  }" placeholder="选择结束时间" :disabled="row.isWork === '2'">
                  </el-time-select>
                </div>
                <div class="date" v-if="row.timeNumber === '2'">
                  <el-time-select v-model="row.time2Start" :picker-options="{
                    start: row.time1End ? row.time1End : '00:00',
                    step: '00:15',
                    end: row.time2End ? row.time2End : '23:45',
                    minTime: row.time1End
                  }" placeholder="选择开始时间" :disabled="row.isWork === '2'">
                  </el-time-select>
                  <span> - </span>
                  <el-time-select v-model="row.time2End" :picker-options="{
                    start: row.time2Start ? row.time2Start : '00:00',
                    step: '00:15',
                    end: '23:45',
                    minTime: row.time2Start
                  }" placeholder="选择结束时间" :disabled="row.isWork === '2'">
                  </el-time-select>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="90px" fixed="right" align="center">
            <template v-slot="{ row }">
              <div>
                <el-button type="text" @click="onAdd(row)" :disabled="row.isWork === '2'"
                  v-if="row.timeNumber === '1'">添加</el-button>
                <el-button type="text" @click="onDelete(row)" :disabled="row.isWork === '2'"
                  v-if="row.timeNumber === '2'" style="color: #FF402B">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="interval">
          <div class="intervalWork">
            <span>周期性工作：</span>
            <el-switch v-model="controlData.cuttp" active-value="1" inactive-value="2" active-color="#1AD1B0"
              inactive-color="#BFBFBF" active-text="关" inactive-text="开">
            </el-switch>
          </div>
          <div class="cutGrass">
            <span>割草间隔时间：</span>
            <el-input-number v-model="controlData.cuttpNum" :min="1"></el-input-number>
          </div>
        </div>
        <div class="mt20" align="center">
          <el-button type="primary" @click="submit()">保存</el-button>
          <el-button @click="closeSubmit()">取消</el-button>
        </div>
      </table>
    </el-dialog>

    <el-dialog title="作业区域" :visible.sync="dialogVisible2" :destroy-on-close="true" :close-on-click-modal="false"
      width="950px" class="dialog-form">
      <div class="workArea">
        <div v-if='this.areaList && this.areaList.length > 0' id="map"></div>
        <div v-else class="map">暂无作业区域</div>
      </div>
    </el-dialog>

    <el-dialog title="区域选择" :visible.sync="dialogVisible3" :destroy-on-close="true" :close-on-click-modal="false"
      width="950px" class="dialog-form">
      <div class="areaChoose">
        <div class="quyu-left">
          <div v-if='this.deviceMapList && this.deviceMapList.length > 0'>
            <el-table class="global-table mb20 dlg-table" max-height="350" :data="deviceMapList" ref="form">
              <el-table-column label="区域选择" show-overflow-tooltip header-align="center">
                <template slot-scope="scope">
                  <el-radio v-model="selectedMap" :label="scope.row.mapName" @change="handleRadioChange(scope.row)">
                  </el-radio>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt20 subutton" align="center">
              <el-button type="primary" @click="submitMap()">确定</el-button>
              <el-button @click="closeSubmitMap()">取消</el-button>
            </div>
          </div>
          <div v-else class="map">暂无区域可选择</div>
        </div>
        <div class="quyu-right" v-if="dialogVisible3" id="map2" ref="map2"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { drawPolygon, dayFormat } from '@/utils/formatData'
export default {
  name: 'DeviceDetail',
  data() {
    return {
      deviceNumber: '',
      date: [],
      sumecInfo: {
        chargeLongitude: '',
        chargeLatitude: '',
        deviceNumber: '',
      },
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      sumecInfo: {},
      areaLocationList: [],
      map: null,
      ploygons: [],
      markers: [],
      baseImg: require('../../../assets/icon/sumec/base.svg'),
      tableData: [],
      loading: false,
      childLoading: false,
      childTableData: [],
      expands: [],
      childPage: 1,
      childSize: 50,
      childTotal: 0,
      getMore: false,
      rowData: null,
      rowMowingId: '',
      active: '',
      controlData: {
        cuttpNum: '',
        deviceNumber: '',
        cuttp: '',
        rain: '',
        led: '',
        cuttimeList: []
      },
      dialogVisible1: false,
      taskData: [],
      taskInfoData: [],
      taskLoading: false,
      isCheck: false,
      isOrder: true, // 是否可下发指令
      workLoading: false,
      dialogVisible2: false,
      //
      areaList: [],
      page: 1,
      size: 10,
      total: 0,
      dialogVisible3: false,
      deviceMapList: [],
      deviceMapNameList: [],
      deviceMapName: '',
      selectedMap: '',
      map2: null
    }
  },
  computed: {
    isShowArea() {
      return this.areaList.length > 0
    }
  },
  created() {
    this.deviceNumber = this.$route.params.deviceNumber || ''
    this.active = this.$route.query.state || 'DeviceInfo'
    this.defaultDate()
    this.getSumecDetail()
    this.getDeviceMapList()
  },
  mounted() {
  },
  destroyed() {
    if (this.map) {
      this.map.clearMap()
    }
  },
  methods: {
    defaultDate() {
      // 默认最近一个月
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
      this.date = [dayFormat(start.getTime()), dayFormat(end.getTime())]
      this.getTableData()
    },

    // 获取割草机配置详情
    getSumecDetail() {
      this.workLoading = true
      this.$axios.get(this.$apis.moving.selectJgMowingInfoMapByList, {
        deviceNumber: this.deviceNumber
      }).then((res) => {
        this.sumecInfo = res[0] || {}
        this.controlData = res[0] || []
        this.deviceMapName = res[0].mapName
        this.handleData(res[0])
        this.areaList = res[0].locationList || []
      }).finally(() => {
        this.workLoading = false
      })
    },


    // 处理详情表格数据
    handleData(res) {
      const weekData = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      res.cuttimeList.forEach((item, index) => {
        item.week = weekData[index]
        if (item.time2Start === '00:00' && item.time2End === '00:00') {
          item.timeNumber = '1'
          item.time2Start = null
          item.time2End = null
          if (item.time1Start === '00:00' && item.time1End === '00:00') {
            item.timeNumber = '1'
            item.time1Start = null
            item.time1End = null
          }
        } else {
          item.timeNumber = '2'
        }
      })
      this.taskData = JSON.parse(JSON.stringify(res.cuttimeList))
      this.taskInfoData = res.cuttimeList
      for (let i = this.taskInfoData.length - 1; i >= 0; i--) {
        if (this.taskInfoData[i].isWork === '2') {
          this.taskInfoData.splice(i, 1)
        }
      }
    },

    // 获取表格数据
    getTableData() {
      this.loading = true
      const info = {
        startTime: this.date[0],
        endTime: this.date[1],
        deviceNumber: this.deviceNumber
      }
      this.$axios.get(this.$apis.iot.selectMowingDataByList, {
        ...info,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },

    // 作业区域弹窗
    getWorkArea() {
      this.dialogVisible2 = true
      this.getProjectLocation()
    },

    // 获取项目信息及项目电子围栏
    getProjectLocation() {
      this.$axios.get(this.$apis.project.selectJgProjectMapByProjectId, {
        projectId: this.$route.params.projectId
      }).then((res) => {
        this.$nextTick(() => {
          this.loadMap(res, res.getProjectLocation)
        })
      })
    },

    // 渲染地图
    loadMap(projectInfo, list) {
      const center = [Number(projectInfo.longitude), Number(projectInfo.latitude)]
      const map = new AMap.Map('map', {
        center: center,
        zoom: 11
      })
      this.map = map
      this.ploygons = drawPolygon(this.map, list || [], null)

      // 基站添加
      if (this.sumecInfo.chargeLongitude && this.sumecInfo.chargeLatitude) {
        const markerBase = new AMap.Marker({
          icon: new AMap.Icon({
            // 图标的取图地址
            image: this.baseImg
          }),
          clickable: false,
          offset: new AMap.Pixel(-19, -18),
          position: new AMap.LngLat(Number(this.sumecInfo.chargeLongitude), Number(this.sumecInfo.chargeLatitude))
        })
        this.map && this.map.add(markerBase)
      }
      const areaList = this.areaList.map((areaItem) => {
        return {
          fenceCode: areaItem.fenceCode || '',
          longitude: Number(areaItem.longitude),
          latitude: Number(areaItem.latitude)
        }
      })
      drawPolygon((this.map), areaList, {
        fillColor: 'rgb(69, 182, 172)', // 背景色
        fillOpacity: 0.7, // 背景透明
        strokeWeight: 2, // 线条宽度
        strokeColor: 'rgba(69, 182, 172, 1)', // 线条色
        strokeStyle: 'dashed', // 线条轮廓线样式
        clickable: false // 是否可点击
      })
    },

    onSearch() {
      this.page = 1
      this.getTableData()
    },

    indexMethod(index) {
      return index + 1
    },

    // 控制台
    // 开启设备
    openDevice() {
      if (this.isOrder) {
        this.sendOrder({ motion: '1' })
      } else {
        this.$message.warning('正在下发指令，请勿重复操作')
      }
    },

    // 区域选择
    // 获取地图
    getDeviceMapList() {
      this.$axios.get(this.$apis.moving.selectSumecConfigMapByList, {
        deviceNumber: this.deviceNumber
      }).then((res) => {
        console.log(res, 'res')
        this.deviceMapNameList = res || []
        this.getCurrentMap()
      })
    },
    // 当前地图
    getCurrentMap() {
      this.$axios.get(this.$apis.moving.selectJgMowingInfoMapByList, {
        deviceNumber: this.deviceNumber
      }).then((res) => {
        console.log(res, 'xxx')
        const jgMovingMaps = res[0].jgMovingMaps || [];
        console.log();

        this.deviceMapList = this.deviceMapNameList.map((mapItem) => {
          return {
            mapName: mapItem,
            locationList: jgMovingMaps.filter(point => point.mapName === mapItem).map(points => ({
              latitude: points.latitude,
              longitude: points.longitude
            }))
          }
        })
        console.log(this.deviceMapList, 'this.deviceMapList');

        this.selectedMap = res.filter(item => item.deviceNumber === this.deviceNumber).mapName || ''
      })
    },
    mapChange() {
      this.dialogVisible3 = true
      this.selectedMap = this.deviceMapName
      this.$nextTick(() => {
        this.initMap2()
      })
    },
    submitMap() {
      this.$axios.post(this.$apis.moving.insertSumecInstructionsMap, {
        deviceNumber: this.deviceNumber,
        mapName: this.selectedMap
      }).then(() => {
        this.$message.success('区域选择成功')
        this.deviceMapName = this.selectedMap
        this.dialogVisible3 = false
        this.getSumecDetail()
      })
    },
    closeSubmitMap() {
      this.dialogVisible3 = false
    },
    initMap2() {
      this.map2 = this.$refs.map2
      this.map2 = new AMap.Map('map2', {
        zoom: 14,
        center: [118.80428, 32.00923]
      })
      if (this.selectedMap) {
        this.showSelectedArea(this.selectedMap)
      }
    },

    // 处理区域选择
    handleRadioChange(row) {
      this.selectedMap = row.mapName
      // this.deviceMapName = row.mapName
      this.showSelectedArea(row.mapName)
    },
    // 显示选中区域
    showSelectedArea(mapName) {
      if (this.map2) {
        this.map2.clearMap(); // 清除旧图形

        // 在数组中查找匹配的区域对象
        const selectedArea = this.deviceMapList.find(item => item.mapName === mapName);
        if (!selectedArea || !selectedArea.locationList) return;

        // 转换坐标格式为 [经度, 纬度]
        const coords = selectedArea.locationList.map(point => {
          return {
            longitude: point.longitude,
            latitude: point.latitude
          };
        });

        // 确保有有效坐标点
        if (coords.length < 3) {
          console.warn('区域坐标点不足，无法绘制多边形');
          return;
        }

        // 绘制多边形
        drawPolygon((this.map2), coords, {
          fillColor: 'rgb(69, 182, 172)', // 背景色
          fillOpacity: 0.7, // 背景透明
          strokeWeight: 2, // 线条宽度
          strokeColor: 'rgba(69, 182, 172, 1)', // 线条色
          strokeStyle: 'dashed', // 线条轮廓线样式
          clickable: false // 是否可点击
        })

        // 调整视野到区域
        this.map2.setFitView();
      }
    },

    // 关闭设备
    closeDevice() {
      if (this.isOrder) {
        this.sendOrder({ motion: '2' })
      } else {
        this.$message.warning('正在下发指令，请勿重复操作')
      }
    },

    // 回充
    chargeDevice() {
      if (this.isOrder) {
        this.sendOrder({ motion: '3' })
      } else {
        this.$message.warning('正在下发指令，请勿重复操作')
      }
    },

    // led灯控
    getLed() {
      if (this.isOrder) {
        if (this.controlData.led) {
          this.controlData.led = this.controlData.led === '1' ? '3' : this.controlData.led === '2' ? '1' : '2'
        } else {
          this.controlData.led = '1'
        }
        this.sendOrder({ led: this.controlData.led })
      } else {
        this.$message.warning('正在下发指令，请勿重复操作')
      }
    },

    // 雨天作业开关
    changeRainWork() {
      if (this.isOrder) {
        this.sendOrder({ rain: this.controlData.rain })
      }
    },

    // 发送割草机指令
    sendOrder(data) {
      this.isOrder = false
      const info = {
        deviceNumber: this.deviceNumber,
        ...data
      }
      this.$axios.post(this.$apis.moving.insertMowingInstructions, info).then(() => {
        this.$message.success('发送指令成功')
        this.getSumecDetail()
      }).finally(() => {
        this.isOrder = true
      })
    },

    // 同步时间
    syncTime() {
      if (this.isOrder) {
        this.isOrder = false
        this.$axios.get(this.$apis.moving.insertMowingTime, {
          deviceNumber: this.deviceNumber
        }).then(() => {
          this.$message.success('同步时间成功')
        }).finally(() => {
          this.isOrder = true
        })
      } else {
        this.$message.warning('正在下发指令，请勿重复操作')
      }
    },

    // 同步信息
    syncInformation() {
      if (this.isOrder) {
        this.isOrder = false
        this.$axios.get(this.$apis.moving.insertMowingData, {
          deviceNumber: this.deviceNumber
        }).then(() => {
          this.$message.success('同步信息成功')
        }).finally(() => {
          this.isOrder = true
        })
      } else {
        this.$message.warning('正在下发指令，请勿重复操作')
      }
    },

    // 任务设置
    // 任务设置弹窗
    getTaskConfig() {
      this.dialogVisible1 = true
    },

    // 保存任务设置
    submit() {
      let cycleType = false
      this.taskData.map((item) => {
        if (item.isWork === '1') {
          cycleType = true
        }
      })
      for (let i = 0; i < this.taskData.length; i++) {
        if (this.taskData[i].isWork === '1' && ((this.taskData[i].time1End === null || this.taskData[i].time1Start === null) || ((this.taskData[i].time2End === null || this.taskData[i].time2Start === null) && this.taskData[i].timeNumber === '2'))) {
          this.$message.warning('已勾选工作日请选择时间段！')
          return
        } else if (!cycleType && this.controlData.cuttp === '1') {
          this.$message.warning('未勾选工作日无法开启周期性工作！')
          return
        } else if (this.controlData.cuttp === '1' && this.controlData.cuttpNum > '99') {
          this.$message.warning('最大割草间隔时间为99天！')
          return
        } else {
          this.isCheck = true
        }
      }
      if (this.isCheck) {
        this.taskLoading = true
        this.taskData.forEach((item, index) => {
          delete this.taskData[index].timeNumber
          delete this.taskData[index].week
        })
        const info = {
          deviceNumber: this.deviceNumber,
          cuttp: this.controlData.cuttp,
          cuttpNum: this.controlData.cuttp === '1' ? String(this.controlData.cuttpNum) : '1',
          cuttimeList: this.taskData
        }
        this.$axios.post(this.$apis.moving.insertMowingCuttime, info).then(() => {
          this.$message.success('配置成功！')
          this.dialogVisible1 = false
        }).finally(() => {
          this.getSumecDetail()
          this.taskLoading = false
        })
      }
    },

    // 添加第二时间段
    onAdd(row) {
      row.timeNumber = '2'
    },

    // 删除第二时间段
    onDelete(row) {
      row.timeNumber = '1'
      row.time2End = null
      row.time2Start = null
    },

    // 取消设置
    closeSubmit() {
      this.taskLoading = false
      this.dialogVisible1 = false
      this.getSumecDetail()
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/scss/color.scss';

.gray {
  background: #B7B7B7FF !important;
}

.green {
  background: $color-default !important;
}

.title {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  font-family: PingFangSC-Medium, PingFang SC;
}

.icon-right {
  font-size: 30px;
  font-weight: bold;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.device {
  display: flex;
  justify-content: space-between;
  height: 980px;

  li {
    list-style: none;
  }

  .left {
    width: 894px;
    min-width: 894px;
    height: 100%;

    .leftTop {
      width: 100%;

      .leftTopTitle {
        display: flex;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;

        span:nth-child(1) {
          font-weight: bold;
          color: #333333;
          font-family: PingFangSC-Medium, PingFang SC;
        }

        span:nth-child(2) {
          color: #999999FF;
          margin: 0 8px 0 4px;
        }

        .state {
          font-size: 12px;
          height: 20px;
          line-height: 12px;
          color: #fff;
          background: #B7B7B7FF;
          padding: 4px 10px;
          border-radius: 2px;
          margin-top: 4px;
        }
      }

      .deviceInfo {
        .deviceTop {
          font-size: 12px;
          padding-bottom: 20px;

          .title {
            margin-bottom: 10px;
          }

          ul {
            margin: 20px 0 0;
            display: flex;
            justify-content: start;

            li {
              width: 25%;
              font-size: 14px;
              color: #000000D9;

              ::v-deep .el-switch__core {
                width: 44px !important;
                height: 22px;
                border-radius: 11px;
                border: none;
              }

              ::v-deep .el-switch__core::after {
                width: 18px;
                height: 18px;
                top: 2px;
              }

              ::v-deep .el-switch.is-checked .el-switch__core::after {
                margin-left: -19px;
              }

              ::v-deep .el-switch__label--right {
                position: absolute;
                z-index: 1;
                right: 8px;
                color: #FFF;

                span {
                  font-size: 12px;
                }
              }

              ::v-deep .el-switch__label.is-active {
                display: none;
              }

              ::v-deep .el-switch__label--left {
                position: absolute;
                z-index: 1;
                left: 8px;
                color: #FFF;

                span {
                  font-size: 12px;
                }
              }
            }

            li:nth-child(3) {
              display: flex;
              width: 50%;

              .getWorkArea {
                margin-left: 8px;
              }
            }
          }
        }

        .deviceMiddle {
          padding: 20px 0;
          border-top: 1px solid #EAEEF5FF;
          border-bottom: 1px solid #EAEEF5FF;

          ul {
            margin: 20px 0 0px 0;
            display: flex;
            justify-content: start;

            li {
              width: 25%;
              font-size: 14px;
              color: #000000D9;

              p {
                &:nth-child(1) {
                  margin-bottom: 20px;
                }

                .state {
                  font-size: 12px;
                  color: #fff;
                  padding: 2px 8px;
                  background: #B7B7B7FF;
                  border-radius: 2px;
                }

                .green {
                  background: #45B6ACFF;
                }

                .yellow {
                  background: #FFC117;
                }

                .blue {
                  background: #1EA2FF;
                }

                span {
                  color: #666666FF;
                }
              }
            }
          }

          .warning {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #FE3A2FFF;
            margin-top: 16px;

            .el-icon-warning {
              font-size: 18px;
            }

            .warningName {
              margin: 0 10px 0 4px;
              color: #000000FF;
            }
          }
        }

        .main {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin: 24px 0 20px 0;

          .mainLeft {
            width: 478px;
          }

          .mainRight {
            width: 360px;
          }

          ul {
            margin-top: 10px;
            padding: 20px 16px;
            background: #FCFCFC;
            border-radius: 2px;
            display: flex;
            justify-content: space-between;

            li {
              text-align: center;
              font-size: 24px;
              padding-top: 6px;
              height: 66px;
              display: flex;
              flex-flow: column;
              justify-content: space-between;

              p {
                font-size: 14px;
                line-height: 28px;
                color: #999999FF;
              }

              .signal {
                height: 31px;
                width: 26px;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                margin: 0 auto 5px auto;

                div {
                  width: 5px;
                  background: #EAEAEAFF;
                  background: $color-default;
                }

                div:nth-child(1) {
                  height: 6px;
                }

                div:nth-child(2) {
                  height: 11px;
                }

                div:nth-child(3) {
                  height: 16px;
                }

                div:nth-child(4) {
                  height: 20px;
                }
              }

              .satellite {
                height: 31px;
                display: flex;
                justify-content: space-around;
                align-items: center;

                img {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }
        }
      }

      .controlBoard {
        width: 460px;
        height: 836px;
        background: #F6F7FB;
        border-radius: 4px;
        padding: 0 30px;

        .machine {
          display: flex;
          justify-content: space-between;
          padding: 30px 0;

          .imgs {
            width: 278px;
            height: 161px;
            margin-top: 7px;
          }

          .machineImg {
            background: url('../../../assets/icon/sumec/image_gecaojiqiren_zhengchang.png') no-repeat;
            background-size: 100%;
          }

          .offLine {
            background: url('../../../assets/icon/sumec/image_gecaojiqiren_lixian.png') no-repeat;
            background-size: 100%;
          }

          .machineBtn {
            .syncInfo {
              display: flex;
              justify-content: flex-end;
              cursor: pointer;

              div:nth-child(1) {
                width: 16px;
                height: 16px;
                background: url('../../../assets/icon/sumec/icon_tongbuxiaoxi.svg') no-repeat;
                background-size: 100%;
              }

              div:nth-child(2) {
                padding-left: 6px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 15px;
              }
            }

            .onSyncInfo {
              &:hover {
                div:nth-child(1) {
                  background: url('../../../assets/icon/sumec/icon_tongbuxiaoxi_dianji.svg') no-repeat;
                  background-size: 100%;
                }

                div:nth-child(2) {
                  color: #1AD1B0;
                }
              }
            }

            .rainWork {
              padding-top: 44px;

              ::v-deep .el-switch__core {
                width: 88px !important;
                height: 32px;
                background: gray;
                border-radius: 16px;
                border: none;
              }

              ::v-deep .el-switch__core::after {
                width: 24px;
                height: 24px;
                top: 4px;
                left: 4px;
                background-color: #FFF;
              }

              ::v-deep .el-switch.is-checked .el-switch__core::after {
                margin-left: 56px;
              }

              ::v-deep .el-switch__label--right {
                position: absolute;
                z-index: 1;
                right: 8px;
                color: #FFF;

                span {
                  font-size: 12px;
                  line-height: 12px;
                  font-weight: 500;
                  font-family: PingFangSC-Medium, PingFang SC;
                }
              }

              ::v-deep .el-switch__label.is-active {
                display: none;
              }

              ::v-deep .el-switch__label--left {
                position: absolute;
                z-index: 1;
                left: 8px;
                color: #FFF;

                span {
                  font-size: 12px;
                  line-height: 12px;
                  font-weight: 500;
                  font-family: PingFangSC-Medium, PingFang SC;
                }
              }
            }

            .ledLamp {
              padding: 10px 26px;
              box-shadow: 0px 4px 8px 0px rgba(141, 141, 141, 0.4);
              border-radius: 4px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              line-height: 12px;
              margin-top: 20px;
            }

            .onLed {
              background: #FFFFFF;
              border-image: linear-gradient(315deg, rgba(202, 202, 202, 1), rgba(243, 243, 243, 1), rgba(204, 204, 204, 1)) 1 1;
              color: #595959;

              &:hover {
                background-color: #1AD1B0;
                color: #FFFFFF;
                cursor: pointer;
              }
            }

            .offLineLed {
              background: #E5E5E5;
              color: #FFFFFF;
              cursor: pointer;
            }
          }
        }

        .setUp {
          display: flex;
          justify-content: space-between;
          padding: 30px 0;
          border-top: 1px solid #DDDDDD;
          ;

          .backWash {
            height: 96px;
            width: 120px;
            box-shadow: 0px 4px 8px 0px rgba(141, 141, 141, 0.4);
            border-radius: 4px;

            .bwImg {
              width: 32px;
              height: 32px;
              margin: 0 auto;
              margin-top: 20px;
            }

            .bwTxt {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              line-height: 22px;
              margin-top: 10px;
              text-align: center;
            }
          }

          .onBW {
            background: #FFFFFF;
            border-image: linear-gradient(315deg, rgba(202, 202, 202, 1), rgba(243, 243, 243, 1), rgba(204, 204, 204, 1)) 1 1;

            .bwImg {
              background: url('../../../assets/icon/sumec/icon_huichong.svg') no-repeat;
            }

            .imgTwo {
              background: url('../../../assets/icon/sumec/icon_tongbushijian.svg') no-repeat;
            }

            .imgThree {
              background: url('../../../assets/icon/sumec/icon_renwushezhi.svg') no-repeat;
            }

            .bwTxt {
              color: #595959;
            }

            &:hover {
              background: #1AD1B0;
              cursor: pointer;

              .bwImg {
                background: url('../../../assets/icon/sumec/icon_huichong_dianji.svg') no-repeat;
              }

              .imgTwo {
                background: url('../../../assets/icon/sumec/icon_tongbushijian_dianji.svg') no-repeat;
              }

              .imgThree {
                background: url('../../../assets/icon/sumec/icon_renwushezhi_dianji.svg') no-repeat;
              }

              .bwTxt {
                color: #FFFFFF;
              }
            }
          }

          .offLineBW {
            background: #EEEEEE;
            border: 1px solid #D9D9D9;
            cursor: pointer;

            .bwImg {
              background: url('../../../assets/icon/sumec/icon_huichong_lixian.svg') no-repeat;
            }

            .imgTwo {
              background: url('../../../assets/icon/sumec/icon_tongbushijian_lixian.svg') no-repeat;
            }

            .imgThree {
              background: url('../../../assets/icon/sumec/icon_renwushezhi_lixian.svg') no-repeat;
            }

            .bwTxt {
              color: #AAAAAA;
            }
          }
        }

        .deviceControl {
          position: relative;
          margin-top: 30px;
          width: 100%;
          background: linear-gradient(180deg, #FFFFFF 0%, #FCFCFC 47%, #F6F6F6 53%, #F3F3F3 100%);
          box-shadow: 0px 4px 8px 0px rgba(141, 141, 141, 0.4), inset 0px -5px 3px 0px #E0E0E0;
          border-radius: 60px;
          height: 80px;
          line-height: 80px;
          text-align: center;
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #36CFC9;

          &:hover {
            background: linear-gradient(180deg, #11E7DE 0%, #11E7DE 47%, #00D3CA 53%, #00D3CA 100%);
            box-shadow: 0px 4px 8px 0px rgba(18, 125, 126, 0.4), inset 0px -5px 3px 0px #0CE4DA;
            color: #FFF;
            cursor: pointer;
          }
        }

        ::v-deep {
          .area {
            position: absolute;
            left: 50%;
            top: 25px;
            transform: translateX(-50%);
            line-height: 0;
          }

          .el-select {
            height: 80px;
            padding-top: 35px;
            width: 100%;
            border: 0;
            line-height: 0;

            input {
              border: 0;
              background: transparent;
              text-align: center;
            }
          }
        }

        .closeColor {
          color: #E86D02;

          &:hover {
            background: linear-gradient(180deg, #FD8131 0%, #FD8131 47%, #FC6300 53%, #FC6300 100%);
            box-shadow: 0px 4px 8px 0px rgba(141, 141, 141, 0.4), inset 0px -5px 3px 0px #FF934D;
            color: #FFF;
            cursor: pointer;
          }
        }

        .offLineDc {
          position: relative;
          cursor: pointer;
          margin-top: 30px;
          width: 100%;
          border-radius: 60px;
          height: 80px;
          line-height: 80px;
          text-align: center;
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          background: #FFFFFF;
          box-shadow: 0px 4px 8px 0px rgba(141, 141, 141, 0.2), inset 0px -5px 3px 0px #E0E0E0;
          color: #DDDDDD;
        }
      }
    }
  }

  .right {
    width: calc(100% - 892px);
    min-width: 470px;
    height: 100%;
    margin-left: 16px;

    .info {
      .title {
        margin: 0px 0px 2px 8px;
      }

      padding: 0 0 20px 0;
      margin: 0 -8px;

      ul {
        display: flex;
        justify-content: space-between;

        li {
          flex: 1;
          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: center;
          min-width: 140px;
          height: 104px;
          padding: 20px 0;
          margin: 8px;
          background: #FCFCFCFF;
          border-radius: 2px;

          p:nth-child(1) {
            font-size: 14px;
            line-height: 22px;
            color: #00000073;
          }

          p:nth-child(2) {
            font-size: 30px;
            color: #000000D9;
          }
        }
      }

      @media screen and (max-width: 1650px) {
        ul {
          justify-content: center;
          flex-flow: column;
        }
      }
    }

    .search {
      ::v-deep .el-button {
        height: 30px;
        margin-left: 16px;
      }
    }
  }
}

.dates {
  display: flex;

  .date {
    margin-left: 24px;

    .el-input {
      width: 140px;
    }
  }
}

.interval {
  display: flex;
  margin: 0px 0px 100px;

  .intervalWork {
    margin-top: 5px;

    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
    }

    ::v-deep .el-switch__core {
      width: 72px !important;
      height: 32px;
      background: gray;
      border-radius: 16px;
      border: none;
    }

    ::v-deep .el-switch__core::after {
      width: 23px;
      height: 23px;
      top: 4px;
      left: 4px;
      background-color: #FFF;
    }

    ::v-deep .el-switch.is-checked .el-switch__core::after {
      margin-left: 41px;
    }

    ::v-deep .el-switch__label--right {
      position: absolute;
      z-index: 1;
      right: 16px;
      color: #FFF;

      span {
        font-size: 12px;
        line-height: 12px;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }

    ::v-deep .el-switch__label.is-active {
      display: none;
    }

    ::v-deep .el-switch__label--left {
      position: absolute;
      z-index: 1;
      left: 16px;
      color: #FFF;

      span {
        font-size: 12px;
        line-height: 12px;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
  }

  .cutGrass {
    margin-left: 48px;

    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}

.timeDis {
  margin-left: 16px
}

.workArea {
  .info {
    display: flex;
    font-size: 14px;
    color: #000000D9;
    margin: 20px 0 15px 0;

    span {
      color: #666666FF;
      margin-right: 70px;
    }
  }

  #map,
  .map {
    width: 100%;
    height: 460px;
    background: #FCFCFCFF;
    border-radius: 2px;
  }

  .map {
    font-size: 24px;
    color: #999999FF;
    text-align: center;
    line-height: 460px;
  }
}

.areaChoose {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  height: 400px;

  .quyu-left {
    width: 290px;
    flex: 1;
    height: 100%;
    //   .subutton {
    //   position: absolute;
    //   bottom: 30px;
    //   left: 90px;
    // }
  }


  .quyu-right {
    width: 600px;
    height: 400px;
  }
}

::v-deep .el-table__expanded-cell {
  margin: 0;
  padding: 0;
}

::v-deep .el-tabs__item {
  margin: 7px 0;
}

::v-deep .amap-marker-label {
  border: 0;

  .marker-label-content {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }

  &::after {
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-5px);
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    /* 三角形左边透明 */
    border-right: 5px solid transparent;
    /* 三角形右边透明 */
    border-top: 5px solid #FFFFFF;
    /* 三角形顶部为黑色，可以根据需要修改颜色 */
  }
}
</style>
